import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children }) => {
  const { access, loading } = useAuth();
  const location = useLocation();

  // While checking session AND we have no token yet, show loader
  if (loading && !access) {
    return <div className="card">Checking session…</div>;
  }

  // When we know we're not logged in, redirect to login
  if (!loading && !access) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // We have an access token → show protected content
  return children;
};

export default PrivateRoute;
